import { OIQ_UI_SVG_LIBRARY_FACTORY, OiqUiSvgLibrary } from '@oiq-ui-sdk/ui';
import { fileSolidSvg } from './file-solid.svg';
import { spinnerSvg } from './spinner.svg';
import { productMCA } from './term-loans/product-mca.svg';
import { productTermLoans } from './term-loans/product-term-loans.svg';

import { presetCustom } from './term-loans/preset-custom.svg';
import { presetEquipmentFinancing } from './term-loans/preset-equipment-financing.svg';
import { presetEquipmentLeasing } from './term-loans/preset-equipment-leasing.svg';
import { presetMortgage } from './term-loans/preset-mortgage.svg';
import { presetTermLoan } from './term-loans/preset-term-loan.svg';
import { uploadOcrSvg } from './upload-ocr.svg';

const appSvgLibrary: OiqUiSvgLibrary = {
  fileSolid: fileSolidSvg,
  spinner: spinnerSvg,
  uploadOcr: uploadOcrSvg,
  termLoansPresetTermLoan: presetTermLoan,
  termLoansPresetEquipmentLeasing: presetEquipmentLeasing,
  termLoansPresetEquipmentFinancing: presetEquipmentFinancing,
  termLoansPresetMortgage: presetMortgage,
  termLoansPresetCustom: presetCustom,
  productMCA: productMCA,
  productTermLoans: productTermLoans,
};

export const APP_SVG_LIBRARY_PROVIDER = OIQ_UI_SVG_LIBRARY_FACTORY(appSvgLibrary);
